"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigRepository = void 0;
const zod_1 = require("zod");
const httpRepository_1 = __importDefault(require("./httpRepository"));
const configSchema = zod_1.z.object({
    TRADESHIFT_GO_HOST: zod_1.z.string(),
    PAYMENTS_EXTERNAL_HOST: zod_1.z.string(),
    FINTECH_PAYMENTS_HOST: zod_1.z.string(),
    VERSION: zod_1.z.string(),
    ENVIROMENT: zod_1.z.string(),
    IS_PRODUCTION: zod_1.z.boolean(),
    IS_SANDBOX: zod_1.z.boolean(),
    IS_DEMO: zod_1.z.boolean(),
    SENTRY_PUBLIC_DSN: zod_1.z.string(),
});
exports.ConfigRepository = {
    get: (key) => {
        const value = globalThis.config[key];
        const partialSchema = zod_1.z.object({ [key]: configSchema.shape[key] });
        const result = partialSchema.safeParse({ [key]: value });
        if (!result.success && !globalThis.IS_PLAYWRIGHT_RUNNING) {
            throw new Error('Validation failed');
        }
        if (result.success) {
            return result.data[key];
        }
        return value;
    },
    getServerVersion: async () => {
        const response = await httpRepository_1.default.tradeshiftGoFrontend().get('/rest/version');
        const result = zod_1.z.string().safeParse(response.data);
        if (!result.success && !globalThis.IS_PLAYWRIGHT_RUNNING) {
            throw new Error('Validation failed');
        }
        return result.success ? result.data : response.data;
    },
    getProviderMappingConfigs: async () => httpRepository_1.default.tradeshiftGo()
        .get('/rest/providerMappingConfigs/')
        .then(response => response.data),
};
